export default __webpack_public_path__ + "static/media/fridge1-before1-1920w.745d92cc.png";